import { render, staticRenderFns } from "./zoneManage.vue?vue&type=template&id=01c2ae1e&"
import script from "./zoneManage.vue?vue&type=script&lang=js&"
export * from "./zoneManage.vue?vue&type=script&lang=js&"
import style0 from "./zoneManage.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "zoneManage.vue"
export default component.exports